import { render, staticRenderFns } from "./AdminRolesList.vue?vue&type=template&id=96d4b148&scoped=true&"
import script from "./AdminRolesList.vue?vue&type=script&lang=js&"
export * from "./AdminRolesList.vue?vue&type=script&lang=js&"
import style0 from "./AdminRolesList.vue?vue&type=style&index=0&id=96d4b148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d4b148",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d4b148')) {
      api.createRecord('96d4b148', component.options)
    } else {
      api.reload('96d4b148', component.options)
    }
    module.hot.accept("./AdminRolesList.vue?vue&type=template&id=96d4b148&scoped=true&", function () {
      api.rerender('96d4b148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminRolesList.vue"
export default component.exports